import {alias, list, createModelSchema} from "serializr";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {RewardTrack} from "@/modules/redactor/models/reward/RewardTrack";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleChristmasHub extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.CHRISTMAS_HUB);

        this._maps = [];

        this._currency = null;

        this._rewards = null;
        this._trackPrize = null;

        this._calendarUID = null;
        this._constructorUID = null;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get rewards() {
        return this._rewards;
    }

    set rewards(value) {
        this._rewards = value;
    }

    get trackPrize() {
        return this._trackPrize;
    }

    set trackPrize(value) {
        this._trackPrize = value;
    }

    get calendarUID() {
        return this._calendarUID;
    }

    set calendarUID(value) {
        this._calendarUID = value;
    }

    get constructorUID() {
        return this._constructorUID;
    }

    set constructorUID(value) {
        this._constructorUID = value;
    }


    get maps() {
        return this._maps;
    }

    set maps(value) {
        this._maps = value;
    }


    valid() {
        if (!super.valid()) {
            console.log("super invalid");
            return false;
        }

        if (this._maps.length === 0) {
            console.log("maps invalid");
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            console.log("currency invalid");
            return false;
        }

        if (this.rewards && !this.rewards.valid()) {
            console.log("rewards invalid");
            return false;
        }

        if (this.trackPrize && !this.trackPrize.valid()) {
            console.log("trackPrize invalid");
            return false;
        }

        if (!this.calendarUID || !RedactorUtils.getSmartOffer(this.calendarUID)) {
            return false;
        }

        if (!this.constructorUID || !RedactorUtils.getSmartOffer(this.constructorUID)) {
            return false;
        }

        return true;
    }

    empty() {
        if (!this.reward || this.reward.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleChristmasHub());
        } else if (target instanceof SmartOfferBundleChristmasHub) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleChristmasHub, {
    _maps: alias("maps", list(MapKindLiteModel.schema())),

    _currency: alias("currency", CurrencyKindModel.schema()),

    _rewards: alias("rewards", RewardTrack.schema()),

    _trackPrize: alias("track_prize", RewardTrack.schema()),

    _calendarUID: alias("calendar_uid", Schema.string()),

    _constructorUID: alias("constructor_uid", Schema.string()),
});